import React from 'react';
import { MdFilterList } from 'react-icons/md';

import { Icon } from '../icon';

export const FiltersContainer = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <div className="flex items-center space-x-2 text-primary-500">
    <Icon icon={<MdFilterList />} />
    <div className="font-medium text-sm">Filter by:</div>
    {children}
  </div>
);
